import client from 'lib/CommonApi/client';

/**
 * 카드 발급 제한 국가코드 목록 조회. (COMMON_CODE 그룹코드 00361)
 * 조회에 실패하면 빈 배열을 반환한다. (fail-open: 아무도 차단하지 않는다)
 */
export const fetchRestrictedCountryCodes = async (languageCode: string): Promise<string[]> => {
  try {
    const response = await client.get('/api/app/comn/codeList', {
      params: {
        groupCode: "00361",
        language: languageCode
      }
    });

    if (response.data.code !== "00" || !Array.isArray(response.data.response)) {
      return [];
    }

    return response.data.response.map((code: { codeValue: string }) => code.codeValue);
  } catch (e) {
    return [];
  }
};

/**
 * 해당 국적이 카드 발급 제한 대상인지 판정한다.
 * 국적을 알 수 없거나 제한 목록이 비어 있으면 차단하지 않는다.
 */
export const isRestrictedCountry = (
  countryCode: string | undefined | null,
  restrictedCountryCodes: string[]
): boolean => {
  if (!countryCode) {
    return false;
  }

  return restrictedCountryCodes.includes(countryCode);
};
